import { getCmsConfigValue } from '@core/infrastructure/state/core.selectors';

export const configTypePercent$ = getCmsConfigValue('type_percent_discount'); // Redondeo (1 || 5)
export const configEnablePercent$ = getCmsConfigValue('show_percent_discount');
export const configEnableTriplePrice$ = getCmsConfigValue('ENABLED_TRIPLE_PRICE');
export const configTriplePricePercent$ = getCmsConfigValue('TRIPLE_PRICE_PERCENTAGE'); // PriceRoundingType Contra qué precio calculamos el porcentaje
export const configTriplePriceRemark$ = getCmsConfigValue('TRIPLE_PRICE_REMARK');

export const prewarmConfig$ = getCmsConfigValue('prewarm_config');
export const vipSalesDateRange$ = getCmsConfigValue('vip_sales_date_range');
export const configCrmActive$ = getCmsConfigValue('is_country_feel');
export const textsDiscountsPrewarmVea$ = getCmsConfigValue('texts_discounts_prewarm_vea');
export const blackFridayDateRange$ = getCmsConfigValue('blackfriday_date_range');
